import { createAction } from 'redux-actions';
import { PapiGruserPage, Gruser } from '../../types/papi';

// Dynamic redux
export const reduxModuleLoaded = createAction('@@gruser.REDUX_READY', () => ({}));

export const init = createAction(
  '@@gruser.GRUSERPAGE.INIT',
  (payload: { gruser: Gruser; gruserPage: PapiGruserPage }) => payload
);
